import axios from 'axios';
import { CANCELLED_REQUEST } from '@client/config/constants';

// TODO remove the requiredField from the calls

// This is a request interceptor which adds the required headers to each request
axios.interceptors.request.use(config => {
    // Concatenate base path if not an absolute URL
    config.url = config.url;

    config.withCredentials = true;
    config.headers = Object.assign({ 'X-Requested-With': 'XMLHttpRequest' }, config.headers);
    if (config.headers['Content-Type']) return config;

    switch (config.method) {
        case 'post':
            // This is so wrong, change this
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            break;
        case 'put':
            config.headers['Content-Type'] = 'application/json';
            break;
        default:
            break;
    }

    return config;
});

export const handleSuccess = (requiredField, response) => {
    if (response && (response.data || response.status === 204)) {
        // check for the required field
        if (requiredField) {
            if (requiredField in response.data) {
                return Promise.resolve(response.data[requiredField]);
            }
        }
        else {
            // no required field present, send response
            return Promise.resolve(response.data);
        }
    }

    return Promise.reject(new Error('No data received'));
};

const handleError = (endpoint, error) => {

    if (error?.message !== CANCELLED_REQUEST) {
        console.error(`Error with request to ${endpoint}:`, error); // eslint-disable-line
    }

    return Promise.reject(error);
};

const jsonHeaders = { headers: { 'Content-Type': 'application/json' } };


/**
 * makes a get request to an endpoint
 * @param  {string} endpoint
 * @param  {object} query
 * @param  {string|null} requiredField - optional field that has to be present in the response
 * @return {Promise}
 */
export function get(endpoint, query = {}, requiredField = null) {
    return axios.get(endpoint, { params: query })
        .then(handleSuccess.bind(this, requiredField))
        .catch(handleError.bind(this, endpoint));
}

/**
 * makes a cancelable get request to an endpoint
 * @return {array[get-method, source]}
 */
export function cancelableGet() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    return [
        (endpoint, query, requiredField) => {
            return axios.get(
                endpoint,
                {
                    params: query,
                    cancelToken: source.token
                })
                .then(handleSuccess.bind(this, requiredField))
                .catch(handleError.bind(this, endpoint));
        },
        source
    ];
}

/**
 * makes a post request to an endpoint
 * @param  {string} endpoint
 * @param  {object} data to post
 * @param  {string|null} requiredField - optional field that has to be present in the response
 * @return {Promise}
 */
export function post(endpoint, data = {}, requiredField = null, config = {}) {
    return axios.post(endpoint, data, config)
        .then(handleSuccess.bind(this, requiredField))
        .catch(handleError.bind(this, endpoint));
}

/**
 * makes a put request to an endpoint
 * @param  {string} endpoint
 * @param  {object} data to put
 * @param  {string|null} requiredField - optional field that has to be present in the response
 * @return {Promise}
 */
export function put(endpoint, data, requiredField = null, config) {
    return axios.put(endpoint, data, config)
        .then(handleSuccess.bind(this, requiredField))
        .catch(handleError.bind(this, endpoint));
}

export function del(endpoint, requiredField = null) {
    return axios.delete(endpoint)
        .then(handleSuccess.bind(this, requiredField))
        .catch(handleError.bind(this, endpoint));
}

export const jsonPost = (endpoint, data, config) => post(endpoint, data, null, Object.assign({}, config, jsonHeaders));

export const jsonPut = (endpoint, data, config) => put(endpoint, data, null, Object.assign({}, config, jsonHeaders));
